import { render, staticRenderFns } from "./BezahlungBestaetigen.vue?vue&type=template&id=12f9aba2"
import script from "./BezahlungBestaetigen.vue?vue&type=script&lang=ts"
export * from "./BezahlungBestaetigen.vue?vue&type=script&lang=ts"
import style0 from "./BezahlungBestaetigen.vue?vue&type=style&index=0&id=12f9aba2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports